import React from 'react';

const WorkPermit = () => {
    return (
        <div class="hero mt-20 mb-16 bg-slate-100 ">
        <div class="hero-content flex-col lg:flex-row mt-14 mb-16">
          <img src="https://i.ibb.co/2gs6WCR/Frame-29-2.png" class="admission" />
          <div>
          <div className='justify-center'>
                  <h1 class="text-start lg:ml-36 text-5xl font-medium text-primary text-3xl font-italic text-gold-600">Work<span className='text-secondary'>Permit</span> </h1>
               
                  <p class="mt-12 text-lg text-justify lg:w-10/12 lg:ml-28">Generation Abroad’s Bangladeshi abroad education consultants can help you get a visiting visa. Our dedicated, industrious, and skilled specialists will work with you one-on-one to succeed. They will also check and arrange your documents to ensure accuracy, help you decide the quantity of finances to present in the right format, prepare you for visa officer interviews, and more. The order and requirements of visitor visa application processes differ by country. Our skilled counselors' ethical and professional assistance will help you choose the best method. With our help, you can determine what to do next and how to get the visa.</p>
               
                </div>
          </div>
        </div>
      </div>
    );
};

export default WorkPermit;